<template>
  <main class="token-info">
    <div class="token-info__wrapper">
      <div class="token-info__img">
        <img src="@/assets/images/no_token.png" alt="Oi, nå ble det kork i champagnen her!" />
      </div>
      <div class="token-info__text">
        <h2>Oi, nå ble det kork i champagnen her!</h2>
        <p>Vi får visst ikke registrert at du gjennomfører kurset.<br />Følg linken fra SMS-en eller e-posten på nytt<br />så Festen kan rulle videre!</p>
      </div>
    </div>
  </main>
</template>

<script>
export default {
    name: "TokenInfo"
}
</script>

<style lang="scss">
    .token-info {
        background: #ebe5dd;
        font-family: $font-token;
        color: #34355f;
        text-align: center;
        width: 100vw;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;

        &__wrapper {
          padding: 30px 20px;
          margin-left: auto;
          margin-right: auto;

          @media (min-width: 360px) {
            max-width: 360px;
          }

          @media (min-width: 500px) {
            max-width: 480px;
            padding: 10px 15px;
          }
        }

        &__img {
          margin-bottom: 10px;

          img {
            width: 80%;
          }

          @media (min-width: 500px) {
            img {
              width: 90%;
            }
          }
        }

        &__text {
          h2 {
            font-size: 1rem;
            font-weight: bold;
            margin-bottom: 15px;
          }

          p {
            font-size: 0.75rem;
            line-height: 1.3;
          }

          @media (min-width: 360px) {
            h2 {
              font-size: 1.2rem;
            }

            p {
              font-size: 0.85rem;
            }
          }

          @media (min-width: 500px) {
            h2 {
              font-size: 1.5rem;
            }

            p {
              font-size: 1.1rem;
            }
          }
        }
    }
</style>